import { render, staticRenderFns } from "./omnimapx.vue?vue&type=template&id=530f486c&scoped=true&"
import script from "./omnimapx.vue?vue&type=script&lang=js&"
export * from "./omnimapx.vue?vue&type=script&lang=js&"
import style0 from "./omnimapx.vue?vue&type=style&index=0&id=530f486c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530f486c",
  null
  
)

export default component.exports